<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.payment_methods_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
					:hasView="true"
				>
					<template v-slot:[`item.image`]="{ item }">
						<v-img
							:src="item.image_url"
							width="80px"
							height="80"
							contain
						></v-img>
					</template>
					<template v-slot:[`item.membership_module`]="{ item }">
						<v-icon color="success" v-if="item.membership_module">
							mdi-check
						</v-icon>
						<v-icon color="error" v-else>mdi-close</v-icon>
					</template>
					<template v-slot:[`item.wallet_module`]="{ item }">
						<v-icon color="success" v-if="item.wallet_module">
							mdi-check
						</v-icon>
						<v-icon color="error" v-else>mdi-close</v-icon>
					</template>
					<template v-slot:[`item.delivery_module`]="{ item }">
						<v-icon color="success" v-if="item.delivery_module">
							mdi-check
						</v-icon>
						<v-icon color="error" v-else>mdi-close</v-icon>
					</template>
					<template v-slot:[`item.pickup_module`]="{ item }">
						<v-icon color="success" v-if="item.pickup_module">
							mdi-check
						</v-icon>
						<v-icon color="error" v-else>mdi-close</v-icon>
					</template>
					<template v-slot:[`item.dine_in_module`]="{ item }">
						<v-icon color="success" v-if="item.dine_in_module">
							mdi-check
						</v-icon>
						<v-icon color="error" v-else>mdi-close</v-icon>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button
			@click="$inertia.visit($route('central.payment_methods.create'))"
		></app-create-fab-button>

		<app-delete-dialog
			ref="deleteDialog"
			:endpoint="'central.payment_methods.destroy'"
			:uuid="item.uuid"
		></app-delete-dialog>
	</v-container>
</template>

<script>
import pickBy from "lodash/pickBy";
export default {
	props: ["data"],
	data() {
		return {
			filter: {},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.payment_methods.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "left",
					width: 80,
				},

				{
					text: this.$t("Image"),
					value: "image",
					sortable: false,
					searchable: false,
					width: 80,
				},
				{
					text: this.$t("Code"),
					value: "code",
					align: "start",
					sortable: false,
					width: 80,
				},
				{
					text: this.$t("Name"),
					value: "name",
					sortable: false,
					searchable: false,
					width: 200,
				},
				{
					text: this.$t("label.membership_module"),
					value: "membership_module",
					searchable: false,
					sortable: false,
					width: 180,
				},
				{
					text: this.$t("label.wallet_module"),
					value: "wallet_module",
					searchable: false,
					sortable: false,
					width: 180,
				},
				{
					text: this.$t("label.delivery_module"),
					value: "delivery_module",
					searchable: false,
					sortable: false,
					width: 180,
				},
				{
					text: this.$t("label.pickup_module"),
					value: "pickup_module",
					searchable: false,
					sortable: false,
					width: 180,
				},
				{
					text: this.$t("label.dine_in_module"),
					value: "dine_in_module",
					searchable: false,
					sortable: false,
					width: 180,
				},
				{
					text: this.$t("Sort Order"),
					value: "sort_order",
					sortable: false,
					searchable: false,
					width: 100,
					align: "center",
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					width: 150,
					align: "right",
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
		editItem(item) {
			this.$inertia.get(
				this.$route("central.payment_methods.edit", item.uuid)
			);
		},

		viewItem(item) {
			this.$inertia.get(
				this.$route("central.payment_methods.show", item.uuid)
			);
		},
		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>